import React from "react";
import SignBuilder from "./SignBuilder";

export default function Pvc() {
  return <SignBuilder product="pvc" />;
}
